import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ProductStore } from '../../../core/models/interfaces-general';
import { ProductImageCarouselComponent } from '../../../shared/components/product-image-carousel.component';

@Component({
  selector: 'app-product-card-store',
  standalone: true,
  imports: [CommonModule, RouterLink, ProductImageCarouselComponent],
  template: `
    <a
      [routerLink]="product.targetUrl || null"
      class="group block w-full bg-white rounded-[2rem] overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 select-none border border-gray-100"
    >
      <div class="relative aspect-square w-full overflow-hidden bg-gray-50">
        <span
          *ngIf="product.badgeText"
          class="absolute top-4 right-4 text-xs font-bold px-3 py-1 rounded-full text-white shadow-sm z-10"
          [ngClass]="{
            'bg-emerald-500': product.badgeType === 'new',
            'bg-rose-500': product.badgeType === 'discount' || !product.badgeType
          }"
        >
          {{ product.badgeText }}
        </span>

        <app-product-image-carousel [images]="imagenes" [alt]="product.title"></app-product-image-carousel>
      </div>

      <div class="p-5 flex flex-col justify-between min-h-[120px]">
        <h3 class="text-gray-700 font-semibold text-sm sm:text-base leading-snug line-clamp-2 group-hover:text-gray-900 transition-colors">
          {{ product.title }}
        </h3>

        <div class="mt-3 flex items-baseline gap-1">
          <span class="text-rose-500 font-extrabold text-lg sm:text-xl">
            S/ {{ product.price.toFixed(2) }}
          </span>
        </div>
      </div>
    </a>
  `
})
export class ProductCardStoreComponent {
  @Input({ required: true }) product!: ProductStore;

  get imagenes(): string[] {
    if (this.product.images && this.product.images.length > 0) {
      return this.product.images;
    }
    return this.product.imageUrl ? [this.product.imageUrl] : [];
  }
}
